//
//
//
//
//
//
//
//

export default {
  props: {
    dark: { type: Boolean, default: false }
  }
}
